import { Showcase } from "./Showcase";
import { Slides } from "./Slides";
import { Cursor } from "./Cursor";
import image1 from "../images/1.jpg";
import image2 from "../images/2.jpg";
import image3 from "../images/3.jpg";
import image4 from "../images/4.jpg";
import smallImage1 from "../images/s-1.jpg";
import smallImage2 from "../images/s-2.jpg";
import smallImage3 from "../images/s-3.jpg";
import smallImage4 from "../images/s-4.jpg";
import image1_dw from "../images/1-t.jpg";
import image2_dw from "../images/2-t.jpg";
import image3_dw from "../images/3-t.jpg";
import image4_dw from "../images/4-t.jpg";
import smallImage1_dw from "../images/s-1-t.jpg";
import smallImage2_dw from "../images/s-2-t.jpg";
import smallImage3_dw from "../images/s-3-t.jpg";
import smallImage4_dw from "../images/s-4-t.jpg";
import logoT from "../images/infinite-evil-logo-t.png";
import logoW from "../images/infinite-evil-logo-w.png";

let img1 = image1.replace(/\//g,'');
let img2 = image2.replace(/\//g,'');
let img3 = image3.replace(/\//g,'');
let img4 = image4.replace(/\//g,'');
let sImg1 = smallImage1.replace(/\//g,'');
let sImg2 = smallImage2.replace(/\//g,'');
let sImg3 = smallImage3.replace(/\//g,'');
let sImg4 = smallImage4.replace(/\//g,'');
let img1_dw = image1_dw.replace(/\//g,'');
let img2_dw = image2_dw.replace(/\//g,'');
let img3_dw = image3_dw.replace(/\//g,'');
let img4_dw = image4_dw.replace(/\//g,'');
let sImg1_dw = smallImage1_dw.replace(/\//g,'');
let sImg2_dw = smallImage2_dw.replace(/\//g,'');
let sImg3_dw = smallImage3_dw.replace(/\//g,'');
let sImg4_dw = smallImage4_dw.replace(/\//g,'');


const html = document.documentElement;
const container = document.getElementById("app");
const cursor = new Cursor(document.querySelector(".cursor"));
const slidesData = [
  {
    image: img1,
    imageDW: img1_dw,
    sImage: sImg1,
    sImageDW: sImg1_dw,
    title: "Infinite Evil",
    meta: "Inside the 'darkest reaches of the Internet'",
    href: "#about",
    sceneTransformX: 0, // change focal point of scene when it's zoomed in
    sceneTransformY: 0,
    imageAlign: 1 // uniform value to pass onto shader for texture mapping alignment. 0 for left, 1 for center, 2 for right
  },
  {
    image: img2,
    imageDW: img2_dw,
    sImage: sImg2,
    sImageDW: sImg2_dw,
    title: "Fighting Hate",
    meta: "How tech companies responded to the Christchurch attacks ",
    href: "#fighting-hate",
    sceneTransformX: 1,
    sceneTransformY: 0,
    imageAlign: 0
  },
  {
    image: img3,
    imageDW: img3_dw,
    sImage: sImg3,
    sImageDW: sImg3_dw,
    title: "Meme Culture",
    meta: "The breakdown of a viral tweet",
    href: "#meme-culture",
    sceneTransformX: -1,
    sceneTransformY: 0,
    imageAlign: 2
  },
  {
    image: img4,
    imageDW: img4_dw,
    sImage: sImg4,
    sImageDW: sImg4_dw,
    title: "The Founder",
    meta: "An interview with the founder of 8chan",
    href: "#the-founder",
    sceneTransformX: 1,
    sceneTransformY: 0,
    imageAlign: 2
  }
];

const slides = new Slides(slidesData);
const showcase = new Showcase(slidesData, {
  onActiveIndexChange: activeIndex => {
    slides.onActiveIndexChange(activeIndex);
  },
  onIndexChange: index => {
    slides.onMove(index);
  },
  onZoomOutStart: ({ activeIndex }) => {
    cursor.enter();
    slides.appear();
  },
  onZoomOutFinish: ({ activeIndex }) => {},
  onFullscreenStart: ({ activeIndex }) => {
    cursor.leave();
    slides.disperse(activeIndex);
  },
  onFullscreenFinish: ({ activeIndex }) => {},
  onShowSupplement: () => {
    html.classList.add("viewing-supplement");
  },
  onHideSupplement: () => {
    html.classList.remove("viewing-supplement");
  }
});

showcase.mount(container);
slides.mount(container);
showcase.render();

// console.log("Credits")
let initClientWidth = document.body.clientWidth;

function onResize(){
  if (window.isMobile) { // ignore height changes on mobile
    if (document.body.clientWidth !== initClientWidth) {
      showcase.onResize();
    }
  } else {
    showcase.onResize();
  } 
};
var resizeTimeout;
window.onresize = function(){
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(onResize, 100);
};

function onMouseMove(ev){
  showcase.onMouseMove(ev);
};
var mouseMoveTimeout;
var mouseMoveDelay = 0;
if (window.isMobile) {
  mouseMoveDelay = 100;
}
window.onmousemove = function(ev) {
  clearTimeout(mouseMoveTimeout);
  mouseMoveTimeout = setTimeout(function(){onMouseMove(ev)}, mouseMoveDelay);
};